import { render, staticRenderFns } from "./A4ASubtestDetailsModal.vue?vue&type=template&id=89837566"
import script from "./A4ASubtestDetailsModal.vue?vue&type=script&lang=js"
export * from "./A4ASubtestDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./A4ASubtestDetailsModal.vue?vue&type=style&index=0&id=89837566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports